import { Component } from '@verndale/core';

class Module extends Component {
  setupDefaults() {
    this.focusedClass = 'field--focused';
  }

  addListeners() {
    this.el.addEventListener('change', this.handleChange.bind(this));
    this.el.addEventListener('keypress', this.handleChange.bind(this));
    this.el.addEventListener('paste', this.handleChange.bind(this));
  }

  handleInputTelKeypress(ev) {
    const $el = ev.srcElement;

    if (ev.key.match(/[^0-9]/g)) {
      ev.preventDefault();
    }
    let input = $el.value;
    if (ev.key !== 'Backspace') {
      if (input.length === 0) {
        input = `${input}(`;
      } else if (input.length === 4) {
        input = `${input})-`;
      } else if (input.length === 9) {
        input = `${input}-`;
      } else if (input.length >= 14) {
        ev.preventDefault();
      }
      $el.value = input;
    }
  }

  format(value) {
    const arrValue = value.split('');
    let formatedValue = '';
    
    // eslint-disable-next-line no-restricted-syntax
    for(let key of arrValue) {

      if (key.match(/[^0-9]/g)) {
        key = '';
      }

      if (formatedValue.length === 0) {
        formatedValue = `${formatedValue}(`;
      } else if (formatedValue.length === 4) {
        formatedValue = `${formatedValue})-`;
      } else if (formatedValue.length === 9) {
        formatedValue = `${formatedValue}-`;
      } else if (formatedValue.length >= 14) {
        key = '';
      }

      formatedValue += key
    }

    return formatedValue;
  }

  handleFormatPhone(ev) {
    const $el = ev.srcElement;
    const { value } = $el;
    if (!value) return;

    $el.value = this.format(value);
    $el.pristine.self.validate($el);
  }

  handleInputTelChange(ev) {
    this.handleFormatPhone(ev);
  }

  handleInputTelPaste(ev) {
    setTimeout(() => {
      this.handleFormatPhone(ev);
    })
  }

  handleChange(ev) {
    const eventTree = {
      keypress: this.handleInputTelKeypress.bind(this),
      change: this.handleInputTelChange.bind(this),
      paste: this.handleInputTelPaste.bind(this)
    }
    const $el = ev.srcElement;
    const func = eventTree[ev.type];
    if ($el.type === 'tel') func(ev);

    if ($el.value) this.handleFocusIn();
  }

  handleFocusIn() {
    this.el.closest('.field')?.classList?.add?.(this.focusedClass);
  }
}

export default Module;
